import { Controller } from 'react-hook-form'
import { isEmpty } from 'lodash'
import { Form } from 'react-bootstrap'

import { MESSAGES, RECIPE_LIMITS, minLengthCheck } from '../utils/recipeLimits'
import { DeleteIcon, DeleteRecipeIcon } from './SvgIcon'
import FieldFeedback from './FieldFeedback'

const RecipeSteps = ({ index, dirtyFields, control, remove }) => {
  const numberStep = index + 1

  return (
    <Controller
      name={`steps.${index}.description`}
      rules={{
        validate: {
          // Saving needs every step written out, for drafts too
          filled: (value) =>
            (!isEmpty(dirtyFields) && !!String(value ?? '').trim()) ||
            MESSAGES.stepEmpty(numberStep),
          minLength: minLengthCheck(MESSAGES.stepMin(numberStep), RECIPE_LIMITS.step.min),
          maxLength: MESSAGES.stepMax(numberStep),
        },
      }}
      control={control}
      render={({ field, fieldState: { error } }) => {
        return (
          <div className="stepWrap">
            <p className="stepTitle">{numberStep}</p>
            <div className="stepTextWrap" data-field>
              <Form.Control
                {...field}
                as="textarea"
                className={`textAreaSteps grayPlaceholder ${error ? 'borderError' : ''}`}
                placeholder={
                  numberStep === 1
                    ? 'Describe the first step of your recipe'
                    : 'Describe the next step of your recipe'
                }
              />
              <FieldFeedback
                error={error}
                value={field.value}
                max={RECIPE_LIMITS.step.max}
                label={`Step ${numberStep}`}
              />
            </div>
            <div onClick={() => remove(index)} className="deleteIcon mobView deleteStepsArray">
              <DeleteRecipeIcon />
            </div>

            <div onClick={() => remove(index)} className="desView deleteStepsArray">
              <DeleteIcon />
            </div>
          </div>
        )
      }}
    />
  )
}

export default RecipeSteps
